function Bars({ title, data, testid }) {
    const rows = Object.entries(data || {});
    const max = Math.max(1, ...rows.map(([, n]) => n));
    return (
        <div className="rounded-2xl bg-white/60 border border-hairline p-6" data-testid={testid}>
            <p className="mono-label text-moss mb-4">{title}</p>
            {rows.length === 0 && <p className="text-sm text-muted_text">No data yet.</p>}
            <ul className="space-y-2.5">
                {rows.map(([k, n]) => (
                    <li key={k} className="text-sm">
                        <div className="flex justify-between gap-3"><span className="truncate">{k}</span><span className="num-mono text-forest">{n}</span></div>
                        <div className="mt-1 h-1.5 rounded-full bg-forest/10"><div className="h-full rounded-full bg-forest" style={{ width: `${(n / max) * 100}%` }} /></div>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default function InvestorStats({ stats }) {
    if (!stats) return null;
    const kpis = [["Completed registrations", stats.completed], ["Last 30 days", stats.last_30_days], ["Completion rate", `${stats.completion_rate}%`], ["Unsubscribed", stats.unsubscribed]];
    return (
        <div className="space-y-4 mb-10" data-testid="ic-admin-stats">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {kpis.map(([l, v]) => (
                    <div key={l} className="rounded-2xl bg-forest text-cream p-6">
                        <p className="mono-label text-sage">{l}</p>
                        <p className="font-serif text-4xl mt-3" data-testid={`ic-kpi-${l.toLowerCase().replace(/\s+/g, "-")}`}>{v}</p>
                    </div>
                ))}
            </div>
            <div className="grid md:grid-cols-3 gap-4">
                <Bars title="Indicative range" data={stats.by_range} testid="ic-stats-range" />
                <Bars title="Interests" data={stats.by_interest} testid="ic-stats-interest" />
                <Bars title="Top sources" data={stats.by_source} testid="ic-stats-source" />
            </div>
            <Bars title="Registration funnel (page view & start only counted for visitors who accepted analytics)" data={Object.fromEntries(stats.funnel)} testid="ic-stats-funnel" />
        </div>
    );
}
